import { connect } from '@vfde-sails/core';
import { selectors as mapStateToProps } from 'Container/App/selector';
import * as priceActions from '../App/action';
import { resetForm } from '../AvailabilityCheck/action';
import { OverlayContent, AppHtmlId } from '../../enums/elementId';
import { debugInfo } from '../../util/debug';
import { mountButton } from '../../components/button';
import { setDisplayMetacode } from '../../util/displayMetacodes';
import { getUpdateFlags } from './update';
import { mountOfferSummaryCard, updateOfferSummaryCard } from '../../components/offerSummaryCard';

const mapDispatch = {
    ...priceActions,
    resetForm,
};

export type State = ReturnType<typeof mapStateToProps>;
type Actions = typeof mapDispatch;

function container (_: State, actions: Actions) {
    const openAvc = () => {
        actions.openOverlay(OverlayContent.FORM);
        actions.resetForm();
    };

    const offerSummaryCard = mountOfferSummaryCard(AppHtmlId.OFFER_SUMMARY_CARD);
    const floatingBtn = mountButton(AppHtmlId.NOTIFICATION_BUTTON, openAvc);

    return {
        getDerivedStateFromProps (newState: State, oldState: State) {
            const { selectedTariff } = newState;
            const update = getUpdateFlags(newState, oldState);

            try {
                if (update.offerSummaryCard) {
                    updateOfferSummaryCard(newState, offerSummaryCard, openAvc, floatingBtn);

                    setDisplayMetacode(
                        offerSummaryCard?.getContainerElement() || '',
                        selectedTariff?.id || ''
                    );
                }
            } catch (error) {
                debugInfo(error);
            }
        },
    };
}

const Container = connect(mapStateToProps, mapDispatch)(container);

export default Container;
